/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoFusionModelsSessionPreview
 */
export interface MelcoFusionModelsSessionPreview {
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsSessionPreview
     */
    image_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsSessionPreview
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsSessionPreview
     */
    url?: string | null;
}

export function MelcoFusionModelsSessionPreviewFromJSON(json: any): MelcoFusionModelsSessionPreview {
    return MelcoFusionModelsSessionPreviewFromJSONTyped(json, false);
}

export function MelcoFusionModelsSessionPreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoFusionModelsSessionPreview {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'image_id': !exists(json, 'image_id') ? undefined : json['image_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function MelcoFusionModelsSessionPreviewToJSON(value?: MelcoFusionModelsSessionPreview | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'image_id': value.image_id,
        'name': value.name,
        'url': value.url,
    };
}


